import cn from 'classnames';
import { Button, Heading, P, Section, Wrapper } from 'components/base';
import { Link } from 'gatsby';
import findIndex from 'lodash-es/findIndex';
import isEmpty from 'lodash-es/isEmpty';
import React, { Component } from 'react';
import DisIcon from 'svgs/events/sme/discount.svg';
import NlLogo from 'svgs/logos/logo-nl-h.svg';
import { pricingTable } from 'utils/nlPricingTable';
import CTAButton from '../CTAButton';
import { activeSeeMore, calculator, discountDesc, disicon, form, icon, input, inputWrapper, label, pricingInfoWrapper, pricingItem, pricingWrapper, radioButton, radioButtons, radioInput, radioMark, radioWrapper, rtext, seeMore, warning } from './PricingCal.module.scss';
import PricingCard from './PricingCard';

const pricingTableShort = pricingTable.slice(0,5);

class PricingCal extends Component {
  constructor() {
    super();

    this.state = {
      sentPerMonth: undefined,
      emailsPerTime: undefined,
      activePlanIndex: undefined,
      budgetMonth: "1",
      showInputWarning: false,
    };
  }

  handleInputChange = event => {
    const key = event.target.name;
    this.setState({ [key]: event.target.value });
  };

  calculate = () => {
    const { sentPerMonth , budgetMonth, emailsPerTime } = this.state;
    const totalEmailAmount = emailsPerTime * sentPerMonth * budgetMonth;
    const isFormInvalid =
      isEmpty(sentPerMonth) ||
      isEmpty(emailsPerTime) ||
      sentPerMonth <= 0 ||
      emailsPerTime <= 0;

    const findBestPlanIndex = (emails, isactivePlan = false) => {
      const index = findIndex(pricingTableShort, o => +o.email >= emails);
      if (isactivePlan && index === 0) {
        return 0; // 小於最小方案
      } else if (isactivePlan) {
        return index - 1; // 建議方案為比較小的級距
      } else {
        return index; // 建議方案為比較大的級距
      }
    };

    const activePlanIndex = isFormInvalid
      ? undefined
      : findBestPlanIndex(totalEmailAmount, false);

    this.setState({
      showInputWarning: isFormInvalid,
      activePlanIndex,
    });
  };

  render() {
    const {
      showInputWarning,
      activePlanIndex,
    } = this.state;

    // const showResult = activePlanIndex !== undefined && !(activePlanIndex < 0);
    const showMassivePlan = activePlanIndex < 0;

    return  (
      <Section id="pricing">
        <Wrapper size="M">
          <Heading bold Tag="h1" center marginBottom="S">疫後振興，新會員限時優惠活動 (已截止)</Heading>
          <div className={discountDesc}>
            <DisIcon className={disicon} />
            <div>
              <P className="mb-xs">疫後振興限時活動，12/31 前電子豹新會員享有首次儲值優惠，限定方案折扣 500 元起。立即註冊成為電子豹新會員，免費試用 30 天，再送優惠券，讓你輕鬆享受低門檻高效益的 Email 行銷體驗。現在，就開始你的電子報行銷佈局吧！</P>
              <P><span className="text-bold">優惠期限：</span>即日起～2021/12/31日止</P>
              <P><span className="text-bold">優惠條件：</span>僅限電子豹新會員，首次付費儲值，享有限定方案優惠乙次。</P>
              <P><span className="text-bold">使用方式：</span><br />
              <ol className="ordered-list">
                <li>註冊試用電子豹，自動領取優惠券。</li>
                <li>需於 12/31 前完成付費，方能享有新會員首儲優惠折扣。</li>
              </ol>
              </P>
            </div>
          </div>
          <div className={pricingInfoWrapper}>
            <NlLogo className={icon} />
          </div>
          <div className={calculator}>
            <div className={form}>
              <label className={inputWrapper}>
                <span className={label}>你的名單數量</span>
                <input
                  className={cn(input, { [warning]: showInputWarning })}
                  onChange={this.handleInputChange}
                  name="emailsPerTime"
                  type="number"
                  placeholder="範例：6,000"
                  min={1}
                />
              </label>
              <label className={inputWrapper}>
                <span className={label}>平均每月會寄幾次？</span>
                <input
                  className={cn(input, { [warning]: showInputWarning })}
                  onChange={this.handleInputChange}
                  name="sentPerMonth"
                  type="number"
                  placeholder="範例：2"
                  min={1}
                />
              </label>
              <div className={inputWrapper}>
                <span className={label}>預估預算期</span>
                <ul className={radioButtons}>
                  <li className={radioButton}>
                    <label className={radioWrapper}>
                      <input className={radioInput} type="radio" name="budgetMonth"
                      value="1" onChange={this.handleInputChange}
                      checked={this.state.budgetMonth === "1"} />
                      <span className={rtext}>一個月</span>
                      <span className={radioMark}></span>
                    </label>
                  </li>
                  <li className={radioButton}>
                    <label className={radioWrapper}>
                      <input className={radioInput} type="radio" name="budgetMonth"
                      value="3" onChange={this.handleInputChange}
                      checked={this.state.budgetMonth === "3"} />
                      <span className={rtext}>三個月</span>
                      <span className={radioMark}></span>
                    </label>
                  </li>
                  <li className={radioButton}>
                    <label className={radioWrapper}>
                      <input className={radioInput} type="radio" name="budgetMonth"
                      value="6" onChange={this.handleInputChange}
                      checked={this.state.budgetMonth === "6"} />
                      <span className={rtext}>半年</span>
                      <span className={radioMark}></span>
                    </label>
                  </li>
                </ul>
              </div>
              <div className="align-item-center">
                <Button
                  type="tertiary"
                  size="M"
                  text="計算"
                  onClick={this.calculate}
                />
              </div>
            </div>
          </div>
        </Wrapper>
        <Wrapper size="M">
          <ul className={pricingWrapper}>
            { pricingTableShort.map((item, i) => (
              <li key={i} className={pricingItem}>
                <PricingCard
                  email={item.email}
                  pricing={item.pricing}
                  discount={item.discount}
                  active={activePlanIndex === i}
                />
              </li>
            )) }
            <li className={cn(seeMore, { [activeSeeMore]: showMassivePlan })}>
              <Link to="/pricing/">看更多<br />方案</Link>
            </li>
          </ul>
          <div className="align-item-center mt-s">
            <CTAButton url="https://app.newsleopard.com/auth/signup?utm_source=SMEcampaignpage&utm_medium=bottomCTA&utm_campaign=2021newuser" />
          </div>
        </Wrapper>
      </Section>
    )
  }
}

PricingCal.propTypes = {};

export default PricingCal;